<template>
  <div>
    <search-bar @onSearch="onSearch"></search-bar>
    <swiper-item :params="params"></swiper-item>
    <van-row class="sort-box">
      <van-col span="8" v-for="item in data" :key="item.foodTypeId">
        <sort-panel :data="item"></sort-panel>
      </van-col>
    </van-row>
    <van-swipe :autoplay="3000" class="bottom-swipe" :show-indicators="false">
      <van-swipe-item v-for="list in bannerList" :key="list.bannerId">
        <a :href="list.resource">
          <div class="banner">
            <img :src="list.bannerPictureUrl" alt>
          </div>
        </a>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Search, Row, Col, Swipe, SwipeItem } from "vant";
import SearchBar from "@/view/eating/components/search-bar";
import SortPanel from "@/view/eating/components/sort-panel";
import SwiperItem from "@/view/eating/components/swiper-item";
import wx from "weixin-js-sdk";
import shareImg from "@/assets/images/home_ic_cye@3x.png";
import { getFoodSpecies, getBanner } from "@/api/eating";
export default {
  data() {
    return {
      value: "",
      data: [],
      bannerList: [],
      announceList: [],
      params: {
        phaseInquire: 0,
        bannerQuantity: 100,
        businessKey: this.$isWechat? 'GZH_WHETHER_CAN_EAT_INDEX': 'APP_WHETHER_CAN_EAT_INDEX'
      }
    };
  },
  components: {
    [Search.name]: Search,
    [Row.name]: Row,
    [Col.name]: Col,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    SearchBar,
    SortPanel,
    SwiperItem
  },
  async created() {
    const res = await getFoodSpecies();
    this.data = res.data;
    const banner = await getBanner();
    this.bannerList = banner.data;
    const shareTitle = "孕e家-能不能吃工具";
    const shareDesc =
      "孕期禁忌千万条，靠谱安全第一条。孕e家能不能吃小工具，一查就知道！";
    const imgUrl = this.getFullImgUrl(shareImg);
    console.log("shareImg", shareImg);
    console.log("imgUrl", imgUrl);
    wx.ready(function() {
      //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        },
        cancal: function() {}
      });
      wx.updateTimelineShareData({
        title: shareTitle, // 分享标题
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function() {
          // 设置成功
          console.log("分享成功");
        }
      });
    });
  },
  methods: {
    onSearch(keyWord) {
      this.$router.push({
        path: "/eating/list",
        query: { foodName: keyWord, foodTypeId: "" }
      });
    },
    getFullImgUrl(shareImg) {
      return window.location.href.split("#")[0].replace(/index.html/, shareImg);
    },
  }
};
</script>
<style lang="less">
.sort-box {
  margin-bottom: 80px;
}
.bottom-swipe {
  height: 50px;
  position: fixed;
  bottom: 0;
  margin: 15px;
  width: calc(100% - 30px);
  .banner {
    align-items: center;
    height: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
</style>


